import { LogService } from "@/services/logging";
import { dexieDB } from "@/services/dexie-database";

export async function insertFile(file: any) {
  LogService.info(
    `Inserting the file into Dexie db for customField Id: ${file.customFieldId}`
  );
  try {
    const fileID = await dexieDB.files.add({
      _id: file._id,
      file: file.file,
      customFieldId: file.customFieldId,
    });
    LogService.info(
      `File inserted successfully for customField Id: ${file.customFieldId}`
    );
  } catch (err) {
    LogService.info(
      `Attached error when inserting the file into Dexie db for customField Id: ${file.customFieldId}`,
      {
        err: err,
      }
    );
  }
}
